import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("cgl_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const setToken = (t) => {
  if (t) localStorage.setItem("cgl_token", t);
  else localStorage.removeItem("cgl_token");
};

export const getToken = () => localStorage.getItem("cgl_token");

// Resolve a media path: absolute URLs pass through, /api/* gets the backend host,
// everything else (e.g. /img/*) is served by the frontend as-is.
export const media = (u) => {
  if (!u) return "";
  if (u.startsWith("http://") || u.startsWith("https://")) return u;
  if (u.startsWith("/api/")) return `${BACKEND_URL}${u}`;
  return u;
};
